<ul class="flex flex-col">
    <li class="flex items-center transition duration-150 cursor-pointer p-20 md:p-30 hover:bg-blue-lighter hover:bg-opacity-25" [ngClass]="{'border-b border-solid border-gray-lighter' : !last}" *ngFor="let item of links; let last = last" (click)="item.Action()">
        <i class="mr-10 material-icons mi-18 text-gray">{{item.Icon}}</i>
        <span class="flex flex-row items-center h-24 flex-grow mr-20 font-bold">{{item.Name}}</span>
        <i class="mr-10 material-icons mi-18 text-gray-light">chevron_right</i>
    </li>
</ul>